import React, { useEffect, useState, useRef } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import Layout from "../../components/common/Layout";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import DatePicker from "react-datepicker";
import checkTime from "../../components/constants/CheckTime"
import { addAuditLog } from "../../components/AuditLog"
import { format } from "date-fns"

const Search = props => {
  const userId =
  JSON.parse(localStorage.getItem("user")) === null
    ? null
    : JSON.parse(localStorage.getItem("user"))[0].Id;
  const handleSort = (column, sortDirection) => {
      setSortedColumn(column.selector);
      setSortDirection(sortDirection);
    };
  
  const exportExcel = () => {
    /* Prepared */
    setLoading(true);    
    //add Audit Log
    addAuditLog({ menu: "CaseSearch" , event: "Export Case Search", createBy: userId });

    const result = [];
    result.push(resultColumns.filter( c => columnsCheckFormData[c.selector]).map( x => x.selector));

    // (dataResult).forEach(item => {
    //   let row = [];
    //   (Object.keys(columnsCheckFormData).filter(k => columnsCheckFormData[k])).forEach(key => {
    //     if(key === 'Image'){
    //       row.push(item['FilePath']);
    //     } else {
    //       row.push(item[key]);
    //     }
    //   });
    //   result.push(row);
    // });

    //console.log(result);

      /* Prepared */
      let filteredArray = dataResult.filter(dataResult => dataResult.Matter != null ).slice();
      filteredArray.sort((a,b) => 
      {
       const aField = a[sortedColumn] 
       const bField = b[sortedColumn]
  
       let comparison = 0;
       
       if (aField > bField) {
        comparison = 1;
       } else if (aField < bField) {
        comparison = -1;
       }
     
       return sortDirection === 'desc' ? comparison * -1 : comparison;
     });
  
      setLoading(true);
      //console.log(`${filteredArray.map(x => x.CaseId)}`);
      //console.log(        `${encodeURIComponent(JSON.stringify(searchFormData))}`   );

      axios.post(process.env.REACT_APP_EXL_URL + "/File/GetCaseSearchExcelById",
      {
        CaseId : `${filteredArray.map(x => x.CaseId)}`,
        Cols: `${result}`,
        Key: 'xGhJjuMTLWfhq6Td8Q4RlAgdwdtwf4ch',
        SortBy: `${sortedColumn}`,
        Sort: `${sortDirection}`,
        filter: `${encodeURIComponent(JSON.stringify(searchFormData))}`,
        },
        { responseType: 'blob' }

    ).then(response => {
      let link = document.createElement('a');
      let day = new Date();

      link.href = window.URL.createObjectURL(new Blob([response.data], 
        {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));;
      link.download = day.toISOString().slice(0,10) + "-CaseSearch_export.xlsx";
      link.click();
    }).catch(error => {
        console.log(error);
    }).finally(() => {
      setLoading(false);
    });  
/*
    axios.get(process.env.REACT_APP_API_URL + "/api/exportexcelcasesearch/", {
      responseType: 'blob',
      params: {col : result, searchFormData}
     }).then(response => {
        let link = document.createElement('a');
        let day = new Date();
     
        link.href = window.URL.createObjectURL(new Blob([response.data], 
          {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));;
        link.download = day.toISOString().slice(0,10) + "-Search_export.xlsx";
        link.click();
     }).catch(error => {
        console.log(error)
     })
*/
  }
  const [isHidden, setIsHidden] = useState({
    references : 0,
    caseDetails : 1,
    text: 1,
    names: 1,
    datas: 1,
    status: 1
  })
  const [dataResult, setDataResult] = useState([]);
  const [showManageColumns, setShowManageColumns] = useState(false);
  const columnsCheckDefault = {
    CaseReference: 1,
    Matter: 1,
    Image: 1,
    CaseOffice: 0,
    
    ProfitCentreName: 0,
    TaxTreatmentName: 0,
    CaseTypeName: 0,
    CountryName: 0,

    BasisName: 0,
    TypeOfMarkName: 0,
    CaseStatusName: 1,
    //InstructorRef: 0,

    Instructor: 0,
    //InstructorCode: 0,
    //InstructorAddress: 0,
    //InstructorTaxId: 0,

    Debtor: 0,
    //DebtorCode: 0,
    //DebtorAddress: 0,
    //DebtorTaxID: 0,

    Owner: 1,
    //OwnerCode: 1,
    //OwnerAddress: 0,
    //OwnerTaxID: 0,

    Agent: 0,
    //AgentCode: 0,
    //AgentAddress: 0,
    //AgentTaxID: 0,

    Refferal: 0,
    //RefferalCode: 0,
    //RefferalAddress: 0,
    //RefferalTaxID: 0,

    Partner: 0,
    //PartnerCode: 0,
    //PartnerAddress: 0,
    //PartnerTaxID: 0,

    Attorney: 0,
    //AttorneyCode: 0,
    //AttorneyAddress: 0,
    //AttorneyTaxID: 0,

    Executive: 0,
    //ExecutiveCode: 0,
    //ExecutiveAddress: 0,
    //ExecutiveTaxID: 0,

    AppNo: 0,
    AppFilingDate: 0,
    RegisNo: 0,
    RegisDate: 0,

    CaseOpenDate: 0,


    RenewalDeadlineDate: 0,
    Deadline: 0,
    //NextRenewalDate: 0,
    ClassList: 0,
    EventList: 0,
    BillableCase: 1,
    //AgentEmail: 0,
    //AgentContact: 0,
    //OwnerEmail: 0,
    //OwnerContact: 0,

    LastUpdateBy: 1,
    LastUpdateDateTime: 1,
    CreateBy: 0,
    CreateDateTime: 0
  };
  const [loading, setLoading] = useState(false);
  const [columnsCheckFormData, setcolumnsCheckFormdata] = useState(columnsCheckDefault);
  const [listColumnsShow, setListColumnsShow] = useState([]);
  const selectDefaultDdl = [
    { value: 0, label: "Start with"},
    { value: 1, label: "End with"},
    { value: 2, label: "Contain"},
    { value: 3, label: "Does not contain"},
    { value: 4, label: "Equal to"},
    { value: 5, label: "Does not equal to"}
  ]
  const [caseOfficeDdl, setCaseOfficeDdl] = useState([{ value: 0, label: "Select All" }]);
  const [caseTypeDdl, setCaseTypeDdl] = useState([{ value: 0, label: "Select All" }]);
  const [countryDdl, setCountryDdl] = useState([{ value: 0, label: "Select All" }]);
  const [basisDdl, setBasisDdl] = useState([{ value: 0, label: "Select All" }]);
  const selectCustom1Ddl = [
    { value: 0, label: "AND"},
    { value: 1, label: "OR"},
    { value: 2, label: "Contain"},
    { value: 3, label: "Does not contain"}
  ];
  const [classCodeDdl, setClassCodeDdl] = useState([]);
  const [typeOfMarkDdl, setTypeOfMarkDdl] = useState([{ value: 0, label: "Select All" }]);
  const [eventDdl, setEventDdl] = useState([{ value: 0, label: "Select All" }]);
  const selectCustom2Ddl = [
    { value: 0, label: "Before"},
    { value: 1, label: "After"},
    { value: 2, label: "Between"}
  ];
  const selectCustom3Ddl = [
    { value: 0, label: "0"},
    { value: 1, label: "1"},
    { value: 2, label: "2"},
    { value: 3, label: "3"},
    { value: 4, label: "4"},
    { value: 5, label: "5"}
  ];
  const [caseStatusDdl, setCaseStatusDdl] = useState([{ value: 0, label: "Select All" }]);

  const reloadResult = async () => {
    /* Prepared */
    setLoading(true);
    await axios.get(process.env.REACT_APP_API_URL + "/api/casesearch2", {params: searchFormData})
    .then(res => {setDataResult(res.data); });
     
    setLoading(false);
  };
  const addLineBreaks = string =>
    string.split("\n").map((text, index) => (
      <React.Fragment key={`${text}-${index}`}>{text}<br/></React.Fragment>
    ));

  const addLinkUrl = string =>{
    
      const parts = string.split(';');
    if (parts.length === 2) {
      const text = parts[0];
      const href = '/cases/view/'+parts[1];
      return <li><a target='_blank' href={href}>{text}</a></li>;
    }
    return null;
  };
  

  const addLineLink = (string) => {
    return string.split("\n").map((line, index) => {
      const link = addLinkUrl(line);
      if (link) {
        return <React.Fragment key={`line-${index}`}>{link}</React.Fragment>;
      }
      return <React.Fragment key={`line-${index}`}>{line}</React.Fragment>;
    });
  };
  

  const resultColumns = [
      {
        cell: row => (
          <div>
            <Link to={"/cases/view/" + row.CaseId} target="_blank">
              <button className="btn btn-sm btn-primary">
                <i className="fa fa-eye"></i> View
              </button>
            </Link>
            <div className="btn-group dropright" style={{verticalAlign:"unset"}}>
              <button 
                type="button" 
                className="btn btn-sm btn-secondary dropdown-toggle ml-2" 
                id={row.CaseId === actionId ? "togget": "untogget"}
                data-toggle="dropdown" 
                aria-haspopup="true" 
                aria-expanded="false"
                //disabled
                value={row.CaseId}
                onClick={(e) => row.CaseId === actionId ? setActionId(0) : setActionId(e.target.value)}
              > Report  </button>
              {row.CaseId === actionId && <div 
                className="dropdown-menu" 
                style={{padding:"0", zIndex:100, display: "flex"}}> 
                <button className="btn-dropdown-item" type="button" ref={filingRef}
                  style={{borderRadius:"3px 0 0 3px", backgroundColor:"rgb(117, 181, 47)"}}
                  onClick={ () => {
                    setActionId(0);
                    //console.log('onclick Filing', row.CaseId);
                    //add Audit Log
                    addAuditLog({ menu: "CaseSearch" , event: "Export ReportFiling", createBy: userId });
  
                    axios
                      .get(process.env.REACT_APP_API_URL + "/api/reportfiling", {
                        params: {caseId : row.CaseId}
                      }).then(res => {
                        let link = document.createElement("a");
                        link.href = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," + res.data.base64Str;
                        link.download = row.CaseReference + "_Filing Report.docx";
                        link.click();
                      });
                  }}
                >
                  <i className="fa fa-file-word-o" /> Filing
                </button>
                <button className="btn-dropdown-item" type="button" ref={completionRef}
                  id={row.CaseId + "_Completion"}
                  style={{backgroundColor:"#08BDBD"}} 
                  onClick={ () => {
                    setActionId(0);
                    //console.log('onclick Completion', row.CaseId);
                    //add Audit Log
                    addAuditLog({ menu: "CaseSearch" , event: "Export ReportCompletion", createBy: userId });
  
                    axios
                      .get(process.env.REACT_APP_API_URL + "/api/reportcompletion", {
                        params: {caseId : row.CaseId}
                      }).then(res => {
                        let link = document.createElement("a");
                        link.href = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," + res.data.base64Str;
                        link.download = row.CaseReference + "_Completion Report.docx";
                        link.click();
                      });
                  }}
                > 
                  <i className="fa fa-file-word-o" /> Completion
                </button>
                <button className="btn-dropdown-item" type="button" ref={renewalRef}
                  id={row.CaseId + "_Renewal"}
                  style={{borderRadius:"0 3px 3px 0", backgroundColor:"#F21B3F"}}
                  onClick={ () => {
                    setActionId(0);
                    //console.log('onclick Renewal', row.CaseId);
                    //add Audit Log
                    addAuditLog({ menu: "CaseSearch" , event: "Export ReportRenewal", createBy: userId });
  
                    axios
                      .get(process.env.REACT_APP_API_URL + "/api/reportrenewal", {
                        params: {caseId : row.CaseId}
                      }).then(res => {
                        let link = document.createElement("a");
                        link.href = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," + res.data.base64Str;
                        link.download =  row.CaseReference + "_Renewal Completion Report.docx";
                        link.click();
                      });
                  }}
                >
                  <i className="fa fa-file-word-o" /> Renewal
                </button>
              </div>}
            </div>
          </div>
        ),
        ignoreRowClick: false,
        allowOverflow: true,
        width: "200px",
        button: true,
        show: 1
      },
      {
        name: "Case Reference",
        selector: "CaseReference",
        sortable: true,
        wrap: true
      },
      {
        name: "Matter",
        selector: "Matter",
        sortable: true,
        wrap: true
      },
      {
        cell: row => (
          <img 
            height = "auto" 
            width="100px" 
            style={{ padding: "0px 5px", objectFit: "contain", maxHeight: "100px" }}
            alt="IMG"
            src = {
              row.Image === null || row.Image === undefined ?
              "/images/logo/no-img.png"
              : "/images/uploads" + row.Image
            } />
        ),
        name: "Image",
        selector: "Image",
        sortable: true,
        wrap: true
      },
      {
        name: "Profit Centre",
        selector: "ProfitCentreName",
        sortable: true,
        wrap: true
      },
      {
        name: "Tax Treatment",
        selector: "TaxTreatmentName",
        sortable: true,
        wrap: true
      },
      {
        name: "Case Office",
        selector: "CaseOffice",
        sortable: true,
        wrap: true
      },
      {
        name: "Case Type",
        selector: "CaseTypeName",
        sortable: true,
        wrap: true
      },
      {
        name: "Country",
        selector: "CountryName",
        sortable: true,
        wrap: true
      },
      {
        name: "Basis",
        selector: "BasisName",
        sortable: true,
        wrap: true
      },
      {
        name: "Type Of Mark",
        selector: "TypeOfMarkName",
        sortable: true,
        wrap: true
      },
      {
        name: "Case Status",
        selector: "CaseStatusName",
        sortable: true,
        cell: row => {
          switch (row.CaseStatusName){
            case 'Registered':
              return (<h6>
                <span className="badge badge-success text-left">{row.CaseStatusName}</span>
              </h6>);
            case 'Not yet filed' :
              return (<h6>
                <span className="badge badge-secondary text-left">{row.CaseStatusName}</span>
              </h6>);
            case 'Pending' :
                return (<h6>
                  <span className="badge badge-info text-left">{row.CaseStatusName}</span>
                </h6>)
            case 'Dead' :
                return (<h6>
                  <span className="badge badge-danger text-left">{row.CaseStatusName}</span>
                </h6>)
            default: 
              return (<span></span>)
          }
        }
      },
    /*
      {
        name: "Instructor Reference",
        selector: "InstructorRef",
        sortable: true,
        wrap: true
      },
    */
      {
        name: "Instructor",
        selector: "Instructor",
        sortable: true,
        wrap: true
      },
    /*
      {
        name: "Instructor Code",
        selector: "InstructorCode",
        sortable: true,
        wrap: true
      },
      {
        name: "Address(Instructor)",
        selector: "InstructorAddress",
        sortable: true,
        wrap: true
      },
      {
        name: "TaxID(Instructor)",
        selector: "InstructorTaxId",
        sortable: true,
        wrap: true
      },
    */
      {
        name: "Debtor",
        selector: "Debtor",
        sortable: true,
        wrap: true
      },
    /*
      {
        name: "Debtor Code",
        selector: "DebtorCode",
        sortable: true,
        wrap: true
      },
      {
        name: "Address(Debtor)",
        selector: "DebtorAddress",
        sortable: true,
        wrap: true
      },
      {
        name: "TaxID(Debtor)",
        selector: "DebtorTaxID",
        sortable: true,
        wrap: true
      },
    */
      {
        name: "Owner",
        selector: "Owner",
        sortable: true,
        wrap: true
      },
    /*
      {
        name: "Owner Code",
        selector: "OwnerCode",
        sortable: true,
        wrap: true
      },
      {
        name: "Address(Owner)",
        selector: "OwnerAddress",
        sortable: true,
        wrap: true
      },
      {
        name: "TaxID(Owner)",
        selector: "OwnerTaxID",
        sortable: true,
        wrap: true
      },
    */
      {
        name: "Agent",
        selector: "Agent",
        sortable: true,
        wrap: true
      },
    /*
      {
        name: "Agent Code",
        selector: "AgentCode",
        sortable: true,
        wrap: true
      },
      {
        name: "Address(Agent)",
        selector: "AgentAddress",
        sortable: true,
        wrap: true
      },
      {
        name: "TaxID(Agent)",
        selector: "AgentTaxID",
        sortable: true,
        wrap: true
      },
    */
      {
        name: "Refferal",
        selector: "Refferal",
        sortable: true,
        wrap: true
      },
    /*
      {
        name: "Refferal Code",
        selector: "RefferalCode",
        sortable: true,
        wrap: true
      },
      {
        name: "Address(Refferal)",
        selector: "RefferalAddress",
        sortable: true,
        wrap: true
      },
      {
        name: "TaxID(Refferal)",
        selector: "RefferalTaxID",
        sortable: true,
        wrap: true
      },
    */
      {
        name: "Partner",
        selector: "Partner",
        sortable: true,
        wrap: true
      },
    /*
      {
        name: "Partner Code",
        selector: "PartnerCode",
        sortable: true,
        wrap: true
      },
      {
        name: "Address(Partner)",
        selector: "PartnerAddress",
        sortable: true,
        wrap: true
      },
      {
        name: "TaxID(Partner)",
        selector: "PartnerTaxID",
        sortable: true,
        wrap: true
      },
    */
      {
        name: "Attorney",
        selector: "Attorney",
        sortable: true,
        wrap: true
      },
    /*
      {
        name: "Attorney Code",
        selector: "AttorneyCode",
        sortable: true,
        wrap: true
      },
      {
        name: "Address(Attorney)",
        selector: "AttorneyAddress",
        sortable: true,
        wrap: true
      },
      {
        name: "TaxID(Attorney)",
        selector: "AttorneyTaxID",
        sortable: true,
        wrap: true
      },
    */
      {
        name: "Executive",
        selector: "Executive",
        sortable: true,
        wrap: true
      },
    /*
      {
        name: "Executive Code",
        selector: "ExecutiveCode",
        sortable: true,
        wrap: true
      },
      {
        name: "Address(Executive)",
        selector: "ExecutiveAddress",
        sortable: true,
        wrap: true
      },
      {
        name: "TaxID(Executive)",
        selector: "ExecutiveTaxID",
        sortable: true,
        wrap: true
      },
    */
      {
        name: "Application No.",
        selector: "AppNo",
        sortable: true,
        wrap: true
      },
      {
        name: "Application Filing Date",
        selector: "AppFilingDate",
        sortable: true,
        wrap: true
      },
      {
        name: "Registration No.",
        selector: "RegisNo",
        sortable: true,
        wrap: true
      },
      {
        name: "Registration Date",
        selector: "RegisDate",
        sortable: true,
        wrap: true
      },
      {
        name: "Case Opening Date",
        selector: "CaseOpenDate",
        sortable: true,
        wrap: true
      },      
      {
        name: "Renewal Deadline Date",
        selector: "RenewalDeadlineDate",
        sortable: true,
        wrap: true
      },
      /*
      {
        name: "Next Renewal Date",
        selector: "NextRenewalDate",
        sortable: true,
        wrap: true
      },
      */
      {
        name: "Deadline",
        selector: "Deadline",
        sortable: true,
        wrap: true
      },
      {
        name: "Class",
        selector: "ClassList",
        center: true,
        sortable: true,
        wrap: true
      },
      {
        name: "Event",
        selector: "EventList",
        center: false,
        sortable: true,
        grow: 2,
        wrap: false,
        cell: row => ( row.EventList ? 
          addLineBreaks(row.EventList)//.split(',').join('\n- '))
          : '' )
      },
      {
        name: "Billable Case",
        selector: "BillableCase",
        center: false,
        sortable: true,
        grow: 2,
        wrap: false,
        cell: row => ( row.BillableCase ? 
           <ul> {addLineLink(row.BillableCase)} </ul>
          : '' )
      },      
      /*
      {
        name: "Agent Email",
        selector: "AgentEmail",
        sortable: true,
        wrap: true
      },
      {
        name: "Agent Contact",
        selector: "AgentContact",
        sortable: true,
        wrap: true
      },
      {
        name: "Owner Email",
        selector: "OwnerEmail",
        sortable: true,
        wrap: true
      },
      {
        name: "Owner Contact",
        selector: "OwnerContact",
        sortable: true,
        wrap: true
      },
      */
      {
        name: "Last Update By",
        selector: "LastUpdateBy",
        sortable: true,
        wrap: true
      },
      {
        name: "Last Update Date Time",
        selector: "LastUpdateDateTime",
        sortable: true,
        wrap: true
      },
      {
        name: "Create By",
        selector: "CreateBy",
        sortable: true,
        wrap: true
      },
      {
        name: "Create Date Time",
        selector: "CreateDateTime",
        sortable: true,
        wrap: true,
      }
    ];
  // set default search
  const defaultSearchData = {
    caseReferenceTS: 0, // TS = Type Search
    caseReferenceText: '',
    familyTS: 0,
    familyText: '',
    instructorRefTS: 0,
    instructorRefText: '',
    caseOfficeId: 0,
    caseTypeId: 0,
    countryId: 0,
    basisId: 0,
    class1TS: 0,
    class1ListId: [],
    class2TS: 3,
    class2ListId: [],
    appNoText: '',
    appNoTS: 0,
    titleTS: 0,
    titleText: '',
    typeOfMarkId: 0,
    instructorTS: 0,
    instructorText: '',
    debtorTS: 0,
    debtorText: '',
    ownerTs: 0,
    ownerText: '',
    agentTS: 0,
    agentText: '',
    refferalTS: 0,
    refferalText: '',
    partnerTS: 0,
    partnerText: '',
    attorneyTS: 0,
    attorneyText: '',
    executiveTS: 0,
    executiveText: '',
    eventId: 0,
    eventDateTS: 0,
    eventDateStart: null,
    eventDateEnd: null,
    occurredEventBL: false, // BL = Boolean (checkbox)
    dueEventBL: false,
    completeEventBL: false,
    importannceLevelTS: 0,
    importannceLevelStart: null,
    importannceLevelEnd: null,
    eventNoteTS: 0,
    eventNoteText: '',
    caseStatusId: 0
  };
  const [actionId, setActionId] = useState(0);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);   
  const filingRef = useRef(null);
  const completionRef = useRef(null);
  const renewalRef = useRef(null);
  const [searchFormData, setSearchFormData] = useState(defaultSearchData);
  useEffect(() => {
    checkTime();
    document.addEventListener("mousedown",  (e) => { checkTime(); });
    reloadResult()

    //Test ColumnsStorage
    var columnsResultSearch = JSON.parse(localStorage.getItem("columnsResultSearch")) || columnsCheckDefault;
    if (columnsResultSearch){
      setcolumnsCheckFormdata({ ...columnsCheckDefault, ...columnsResultSearch});
    }

    //load Ddl Tab Case Details
    axios
    .get(process.env.REACT_APP_API_URL + "/api/caseoffice/ddl").then(res => {
      setCaseOfficeDdl([{ value: 0, label: "Select All" }, ...res.data]);
    });
    axios.get(process.env.REACT_APP_API_URL + "/api/casetype/ddl").then(res => {
      setCaseTypeDdl([{ value: 0, label: "Select All" }, ...res.data]);
    });
    axios.get(process.env.REACT_APP_API_URL + "/api/country/ddl").then(res => {
      setCountryDdl([{ value: 0, label: "Select All" }, ...res.data]);
    });
    axios.get(process.env.REACT_APP_API_URL + "/api/basis/ddl").then(res => {
      setBasisDdl([{ value: 0, label: "Select All" }, ...res.data]);
    });
    axios.get(process.env.REACT_APP_API_URL + "/api/classes/ddl").then(res => {
      setClassCodeDdl(res.data);
    });

    //Load Ddl Tab Text
    axios.get(process.env.REACT_APP_API_URL + "/api/typeofmark/ddl").then(res => {
        setTypeOfMarkDdl([{ value: 0, label: "Select All" }, ...res.data]);
      });
    axios.get(process.env.REACT_APP_API_URL + "/api/events/masddl").then(res => {
        setEventDdl([{ value: 0, label: "Select All" }, ...res.data]);
      });

    //Load Ddl Tab Status
    axios
      .get(process.env.REACT_APP_API_URL + "/api/casestatus/ddl")
      .then(res => {
        setCaseStatusDdl([{ value: 0, label: "Select All" }, ...res.data]);
      });
    //eslint-disable-next-line
  },[])
  useEffect(() => {
    if (sortedColumn && sortDirection) {
      console.log(`DataTable is sorted by column: ${sortedColumn} in ${sortDirection} order.`);
    }
  }, [sortedColumn, sortDirection])
  useEffect(() => {
    if(searchFormData.eventDateTS === 0){
      setSearchFormData({ ...searchFormData, eventDateStart: null})
    } else if(searchFormData.eventDateTS === 1){
      setSearchFormData({ ...searchFormData, eventDateEnd: null})
    }
    //eslint-disable-next-line
  },[searchFormData.eventDateTS])
  useEffect(() => {
    if(searchFormData.importannceLevelTS === 0){
      setSearchFormData({ ...searchFormData, importannceLevelStart: null})
    } else if(searchFormData.importannceLevelTS === 1){
      setSearchFormData({ ...searchFormData, importannceLevelEnd: null})
    }
    //eslint-disable-next-line
  },[searchFormData.importannceLevelTS])
  useEffect(() => {
    setListColumnsShow(Object.keys(columnsCheckFormData).reduce((ret, curr) => 
    columnsCheckFormData[curr] ? [...ret, curr] : ret
    , []));
    //Test ColumnsStorage
    localStorage.setItem('columnsResultSearch', JSON.stringify(columnsCheckFormData));

  },[columnsCheckFormData])
  useEffect(() => {
    if(actionId !== 0){
      document.addEventListener("mousedown", (e) => {
        if ((filingRef.current && !filingRef.current.contains(e.target)) 
            && (completionRef.current && !completionRef.current.contains(e.target))
            && (renewalRef.current && !renewalRef.current.contains(e.target))) {
          setActionId(0);
        }
      });
    }
  },[actionId]);

  const customSort = (rows, selector, direction) => {
    return rows.sort((rowA, rowB) => {
      // use the selector function to resolve your field names by passing the sort comparitors
      const aField = typeof selector === 'function' ? selector(rowA) : rowA[selector];
      const bField = typeof selector === 'function' ? selector(rowB) : rowB[selector];

    
      let comparison = 0;
    
      if (aField > bField) {
       comparison = 1;
      } else if (aField < bField) {
       comparison = -1;
      }
      //console.log(aField + " : " + bField + " : " + (direction === 'desc' ? comparison * -1 : comparison));

      return direction === 'desc' ? comparison * -1 : comparison;
     });
   };
  const submitsearch = () => {
    reloadResult();
  };
  const onChangeSelectSearch = (e, name) => {
    setSearchFormData({ ...searchFormData, [name]: e.value})
  }
  const onChangeTextSearch = (e) => {
    setSearchFormData({ ...searchFormData, [e.target.name]: e.target.value })
  }
  const onChangeCustomSearch = (e, name) => {
    setSearchFormData({ ...searchFormData, [name]: e})
  }
  const onChangeCheckColumns = (e) => {
    setcolumnsCheckFormdata({ 
      ...columnsCheckFormData, [e.target.name] : !columnsCheckFormData[e.target.name]
    })
  }

  const checkInputManageColumn = (name) => 
    (<div key={name} className="col-sm-12 col-md-6 col-lg-4 col-xl-3">
        <input 
          type="checkbox" 
          className="checkboxCustom1"
          name={name}
          id={name} 
          defaultChecked={columnsCheckFormData[name]} 
          onChange={onChangeCheckColumns}
          />
        <label htmlFor={name}> {resultColumns.filter( c => c.selector === name)[0].name}</label> 
      </div>)
    
    return (
        <Layout activeLinkTo="/casesearch" menuId="18">
          <div className="table-responsive">
            <div className="container-fluid">
              <div className="card border-secondary"> {/* References */}
                <h5 
                  className="card-header text-white" 
                  style={{backgroundColor:"#45447d", cursor:"pointer"}}
                  onClick={ () => setIsHidden({ ...isHidden, references: !isHidden.references})}>
                  <i className={"fa fa-" + (isHidden.references ? "plus" : "minus") + "-square-o"} />  References
                </h5>
                <div className="card-body" hidden={isHidden.references}>
                  <div className="row">
                    <div className="col-lg-6">
                      <label className="title control-label">
                        Case Reference(s)
                      </label>
                      <div className="input-group">
                        <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                        <Select 
                          onChange={ e => onChangeSelectSearch(e, "caseReferenceTS")}
                          value={selectDefaultDdl[searchFormData.caseReferenceTS]}
                          options={selectDefaultDdl}
                        />
                        </div>
                        <input
                          type="search"
                          className="form-control col-lg-8"
                          name="caseReferenceText"
                          value={searchFormData.caseReferenceText}
                          onChange={onChangeTextSearch}
                          onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <label className="title control-label">
                        Family
                      </label>
                      <div className="input-group">
                        <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                        <Select 
                          onChange={ e => onChangeSelectSearch(e, "familyTS")}
                          value={selectDefaultDdl[searchFormData.familyTS]}
                          options={selectDefaultDdl}
                        />
                        </div>
                        <input
                          type="search"
                          className="form-control col-lg-8"
                          name="familyText"
                          value={searchFormData.familyText}
                          onChange={onChangeTextSearch}
                          onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <label className="title control-label">
                        Instructor Reference
                      </label>
                      <div className="input-group">
                        <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                        <Select 
                          onChange={ e => onChangeSelectSearch(e, "instructorRefTS")}
                          value={selectDefaultDdl[searchFormData.instructorRefTS]}
                          options={selectDefaultDdl}
                        />
                        </div>
                        <input
                          type="search"
                          className="form-control col-lg-8"
                          name="instructorRefText"
                          value={searchFormData.instructorRefText}
                          onChange={onChangeTextSearch}
                          onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                        />
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>
              <p>&nbsp;</p>
              <div className="card border-secondary"> {/* Case Details */}
                <h5 
                  className="card-header text-white"
                  style={{backgroundColor:"#2db3b9", cursor:"pointer"}}
                  onClick={ () => setIsHidden({ ...isHidden, caseDetails: !isHidden.caseDetails})}>
                  <i className={"fa fa-" + (isHidden.caseDetails ? "plus" : "minus") + "-square-o"} />  Case Details
                </h5>
                <div className="card-body" hidden={isHidden.caseDetails}>
                  <div className="row">
                    <div className="col-lg-3">
                      <label className="title control-label">
                        Case Office
                      </label>
                      <Select
                        onChange={ e => onChangeSelectSearch(e, "caseOfficeId")}
                        value={caseOfficeDdl.filter(x => x.value === searchFormData.caseOfficeId)}
                        options={caseOfficeDdl}
                      />
                    </div>
                    <div className="col-lg-3">
                      <label className="title control-label">
                        Case Type
                      </label>
                      <Select 
                        onChange={ e => onChangeSelectSearch(e, "caseTypeId")}
                        value={caseTypeDdl.filter(x => x.value === searchFormData.caseTypeId)}
                        options={caseTypeDdl}
                      />
                    </div>
                    <div className="col-lg-3">
                      <label className="title control-label">
                        Country
                      </label>
                      <Select
                        onChange={ e => onChangeSelectSearch(e, "countryId")}
                        value={countryDdl.filter(x => x.value === searchFormData.countryId)}
                        options={countryDdl}
                      />
                    </div>
                    <div className="col-lg-3">
                      <label className="title control-label">
                        Basis
                      </label>
                      <Select
                        onChange={ e => onChangeSelectSearch(e, "basisId")}
                        value={basisDdl.filter(x => x.value === searchFormData.basisId)}
                        options={basisDdl}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <label className="title control-label">
                        Class
                      </label>
                      <div className="input-group">
                        <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                          <Select 
                            onChange={ e => onChangeSelectSearch(e, "class1TS")}
                            value={selectCustom1Ddl[searchFormData.class1TS]}
                            options={selectCustom1Ddl}
                          />
                        </div>
                        <div className="form-control col-lg-8" style={{padding:0, borderStyle:"hidden"}}>
                        <Select 
                          value={classCodeDdl.filter(x => searchFormData.class1ListId.includes(x.value))}
                          isMulti
                          options={classCodeDdl}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          placeholder="select class code"
                          onChange={ e => onChangeCustomSearch(e.map(x => x.value), "class1ListId")}
                        />
                        </div>
                      </div>
                    </div>
                    <div className="aHuy col-lg-6">
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text">&</span>
                        </div>
                        <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                          <Select 
                            onChange={ e => onChangeSelectSearch(e, "class2TS")}
                            value={selectCustom1Ddl[searchFormData.class2TS]}
                            options={selectCustom1Ddl}
                          />
                        </div>
                        <div className="form-control col-lg-8" style={{padding:0, borderStyle:"hidden"}}>
                          <Select 
                            value={classCodeDdl.filter(x => searchFormData.class2ListId.includes(x.value))}
                            isMulti
                            options={classCodeDdl}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            placeholder="select class code"
                            onChange={ e => onChangeCustomSearch(e.map(x => x.value), "class2ListId")}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                    <label className="title control-label">
                        Appication No.
                      </label>
                      <div className="input-group">
                        <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                        <Select 
                          onChange={ e => onChangeSelectSearch(e, "appNoTS")}
                          value={selectDefaultDdl[searchFormData.appNoTS]}
                          options={selectDefaultDdl}
                        />
                        </div>
                        <input
                          type="search"
                          className="form-control col-lg-8"
                          name="appNoText"
                          value={searchFormData.appNoText}
                          onChange={onChangeTextSearch}
                          onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p>&nbsp;</p>
              <div className="card border-secondary"> {/* Text */}
                <h5 className="card-header text-white"
                  style={{backgroundColor:"rgb(143, 146, 92)", cursor:"pointer"}}
                  onClick={ () => setIsHidden({ ...isHidden, text: !isHidden.text})}>
                  <i className={"fa fa-" + (isHidden.text ? "plus" : "minus") + "-square-o"} />  Text
                </h5>
                <div className="card-body" hidden={isHidden.text}>
                  <div className="row">
                    <div className="col-lg-6">
                      <label className="title control-label">
                        Title / Mark
                      </label>
                      <div className="input-group">
                        <div className="form-control col-lg-6" style={{padding:0, borderStyle:"hidden"}}>
                        <Select 
                          onChange={ e => onChangeSelectSearch(e, "titleTS")}
                          value={selectDefaultDdl.filter(x => x.value === searchFormData.titleTS)}
                          options={selectDefaultDdl}
                        />
                        </div>
                        <input
                          type="search"
                          className="form-control col-lg-8"
                          name="titleText"
                          value={searchFormData.titleText}
                          onChange={onChangeTextSearch}
                          onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <label className="title control-label">
                        Type of Mark
                      </label>
                      <Select
                        onChange={ e => onChangeSelectSearch(e, "typeOfMarkId")}
                        value={typeOfMarkDdl[searchFormData.typeOfMarkId]}
                        options={typeOfMarkDdl}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <p>&nbsp;</p>
              <div className="card border-secondary"> {/* Names */}
                <h5 className="card-header text-white"
                  style={{backgroundColor:"#F38F3A", cursor:"pointer"}}
                  onClick={ () => setIsHidden({ ...isHidden, names: !isHidden.names})}>
                  <i className={"fa fa-" + (isHidden.names ? "plus" : "minus") + "-square-o"} />  Names
                </h5>
                <div className="card-body" hidden={isHidden.names}>
                  <div className="row">
                    <div className="col-lg-6">
                      <label className="title control-label">
                        Instructor
                      </label>
                      <div className="input-group">
                        <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                        <Select 
                          onChange={ e => onChangeSelectSearch(e, "instructorTS")}
                          value={[...selectDefaultDdl, {value: 6, label: "Contains (Addr.)"}][searchFormData.instructorTS]}
                          options={[...selectDefaultDdl, {value: 6, label: "Contains (Addr.)"}]}
                        />
                        </div>
                        <input
                          type="search"
                          className="form-control col-lg-8"
                          name="instructorText"
                          value={searchFormData.instructorText}
                          onChange={onChangeTextSearch}
                          onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <label className="title control-label">
                        Debtor
                      </label>
                      <div className="input-group">
                        <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                        <Select 
                          onChange={ e => onChangeSelectSearch(e, "debtorTS")}
                          value={selectDefaultDdl[searchFormData.debtorTS]}
                          options={selectDefaultDdl}
                        />
                        </div>
                        <input
                          type="search"
                          className="form-control col-lg-8"
                          name="debtorText"
                          value={searchFormData.debtorText}
                          onChange={onChangeTextSearch}
                          onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <label className="title control-label">
                        Owner
                      </label>
                      <div className="input-group">
                        <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                        <Select 
                          onChange={ e => onChangeSelectSearch(e, "ownerTs")}
                          value={[...selectDefaultDdl, {value: 6, label: "Contains (Addr.)"}][searchFormData.ownerTs]}
                          options={[...selectDefaultDdl, {value: 6, label: "Contains (Addr.)"}]}
                        />
                        </div>
                        <input
                          type="search"
                          className="form-control col-lg-8"
                          name="ownerText"
                          value={searchFormData.ownerText}
                          onChange={onChangeTextSearch}
                          onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <label className="title control-label">
                        Agent
                      </label>
                      <div className="input-group">
                        <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                        <Select 
                          onChange={ e => onChangeSelectSearch(e, "agentTS")}
                          value={selectDefaultDdl[searchFormData.agentTS]}
                          options={selectDefaultDdl}
                        />
                        </div>
                        <input
                          type="search"
                          className="form-control col-lg-8"
                          name="agentText"
                          value={searchFormData.agentText}
                          onChange={onChangeTextSearch}
                          onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <label className="title control-label">
                        Refferal
                      </label>
                      <div className="input-group">
                        <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                        <Select 
                          onChange={ e => onChangeSelectSearch(e, "refferalTS")}
                          value={selectDefaultDdl[searchFormData.refferalTS]}
                          options={selectDefaultDdl}
                        />
                        </div>
                        <input
                          type="search"
                          className="form-control col-lg-8"
                          name="refferalText"
                          value={searchFormData.refferalText}
                          onChange={onChangeTextSearch}
                          onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <label className="title control-label">
                        Partner
                      </label>
                      <div className="input-group">
                        <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                        <Select 
                          onChange={ e => onChangeSelectSearch(e, "partnerTS")}
                          value={selectDefaultDdl[searchFormData.partnerTS]}
                          options={selectDefaultDdl}
                        />
                        </div>
                        <input
                          type="search"
                          className="form-control col-lg-8"
                          name="partnerText"
                          value={searchFormData.partnerText}
                          onChange={onChangeTextSearch}
                          onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-6">
                      <label className="title control-label">
                        Attorney
                      </label>
                      <div className="input-group">
                        <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                        <Select 
                          onChange={ e => onChangeSelectSearch(e, "attorneyTS")}
                          value={selectDefaultDdl[searchFormData.attorneyTS]}
                          options={selectDefaultDdl}
                        />
                        </div>
                        <input
                          type="search"
                          className="form-control col-lg-8"
                          name="attorneyText"
                          value={searchFormData.attorneyText}
                          onChange={onChangeTextSearch}
                          onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <label className="title control-label">
                        Executive
                      </label>
                      <div className="input-group">
                        <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                        <Select 
                          onChange={ e => onChangeSelectSearch(e, "executiveTS")}
                          value={selectDefaultDdl[searchFormData.executiveTS]}
                          options={selectDefaultDdl}
                        />
                        </div>
                        <input
                          type="search"
                          className="form-control col-lg-8"
                          name="executiveText"
                          value={searchFormData.executiveText}
                          onChange={onChangeTextSearch}
                          onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p>&nbsp;</p>
              <div className="card border-secondary"> {/* Datas */}
                <h5 className="card-header text-white"
                  style={{backgroundColor:"#e85d91", cursor:"pointer"}}
                  onClick={ () => setIsHidden({ ...isHidden, datas: !isHidden.datas})}>
                  <i className={"fa fa-" + (isHidden.datas ? "plus" : "minus") + "-square-o"} />  Datas
                </h5>
                <div className="card-body" hidden={isHidden.datas}>
                  <div className="row">
                    <div className="col-lg-6">
                      <label className="title control-label">
                          Event
                      </label>
                      <div className="form-control" style={{padding:0, borderStyle:"hidden"}}>
                        <Select
                          onChange={ e => onChangeSelectSearch(e, "eventId")}
                          value={eventDdl.filter(x => x.value === searchFormData.eventId)}
                          options={eventDdl}
                        />
                      </div>
                    </div>
                    <div className="aHuy col-lg-6">
                      <div className="input-group">
                        <div className="form-control" style={{padding:0, borderStyle:"hidden"}}>
                          <Select
                            onChange={ e => onChangeSelectSearch(e, "eventDateTS")}
                            value={selectCustom2Ddl[searchFormData.eventDateTS]}
                            options={selectCustom2Ddl}
                          />
                        </div>
                        { (searchFormData.eventDateTS !== 0) && <DatePicker
                          dateFormat="yyyy/MM/dd"
                          placeholderText="start date"
                          isClearable
                          selected={searchFormData.eventDateStart}
                          maxDate={searchFormData.eventDateEnd}
                          onChange={ e => onChangeCustomSearch(e, "eventDateStart")}
                          selectsStart
                          startDate={searchFormData.eventDateStart}
                          endDate={searchFormData.eventDateEnd}
                          showYearDropdown
                          scrollableYearDropdown
                          customInput={
                            <input
                              className="form-control"
                              style={{
                                borderTopRightRadius: 0,
                                borderBottomRightRadius: 0
                              }}
                            />
                          }
                        />}
                        { (searchFormData.eventDateTS !== 1) && <DatePicker
                          dateFormat="yyyy/MM/dd"
                          placeholderText="end date"
                          isClearable
                          selected={searchFormData.eventDateEnd}
                          minDate={searchFormData.eventDateStart}
                          onChange={ e => onChangeCustomSearch(e, "eventDateEnd")}
                          selectsEnd
                          startDate={searchFormData.eventDateStart}
                          endDate={searchFormData.eventDateEnd}
                          showYearDropdown
                          scrollableYearDropdown
                          customInput={
                            <input
                              className="form-control"
                              style={{
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0
                              }}
                            />
                          }
                        />}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <span style={{fontSize:"x-small", paddingLeft:"12px", margin: "14px"}}> Search For. </span>
                      <div className="btn-group" 
                        onClick={() => setSearchFormData({ ...searchFormData, occurredEventBL: !searchFormData.occurredEventBL})} 
                        style={{marginTop:"7px", height:"37px", marginRight: "15px"}}>
                          <label className="btn btn-primary" style={{width:"40px", paddingTop: "2px"}}>
                            <span className="glyphicon glyphicon-ok">{ searchFormData.occurredEventBL? '✔' : ' ' }</span>
                          </label>
                          <label className="cbB btn btn-default active"> Occurred Event</label>
                      </div>
                      <div className="btn-group" 
                        onClick={() => setSearchFormData({ ...searchFormData, dueEventBL: !searchFormData.dueEventBL})} 
                        style={{marginTop:"7px", height:"37px", marginRight: "15px"}}>
                          <label className="btn btn-danger" style={{width:"40px", paddingTop: "2px"}}>
                            <span className="glyphicon glyphicon-ok">{ searchFormData.dueEventBL? '✔' : ' ' }</span>
                          </label>
                          <label className="cbB btn btn-default active"> Due Event</label>
                      </div>
                      <div className="btn-group" 
                        onClick={() => setSearchFormData({ ...searchFormData, completeEventBL: !searchFormData.completeEventBL})} 
                        style={{marginTop:"7px", height:"37px"}}>
                          <label className="btn btn-success" style={{width:"40px", paddingTop: "2px"}}>
                            <span className="glyphicon glyphicon-ok">{ searchFormData.completeEventBL? '✔' : ' ' }</span>
                          </label>
                          <label className="cbB btn btn-default active"> Complete Event</label>
                      </div>
                  </div>
                  <div className="row"
                          style={{backgroundColor: "rgb(231, 231, 231)", color: "darkgrey", radius: "10px"}} //lock this time
                  >
                    <div className="col-lg-6">
                      <label className="title control-label">
                        Importannce Level
                      </label>
                      <div className="input-group">
                        <div className="form-control" style={{padding:0, borderStyle:"hidden"}}>
                          <Select
                            onChange={ e => onChangeSelectSearch(e, "importannceLevelTS")}
                            value={selectCustom2Ddl[searchFormData.importannceLevelTS]}
                            options={selectCustom2Ddl}
                            isDisabled //lock this time
                          />
                        </div>
                        { (searchFormData.importannceLevelTS !== 0) && <div className="form-control" hidden={false} style={{padding:0, borderStyle:"hidden"}}>
                          <Select
                            onChange={ e => onChangeSelectSearch(e, "importannceLevelStart")}
                            value={selectCustom3Ddl[searchFormData.importannceLevelStart]}
                            options={selectCustom3Ddl.filter(x => x.value <= (searchFormData.importannceLevelEnd || 5))}
                            placeholder="start level"
                            isDisabled //lock this time
                          />
                        </div>}
                        { (searchFormData.importannceLevelTS !== 1) && <div className="form-control" hidden={false} style={{padding:0, borderStyle:"hidden"}}>
                          <Select
                            onChange={ e => onChangeSelectSearch(e, "importannceLevelEnd")}
                            value={selectCustom3Ddl[searchFormData.importannceLevelEnd]}
                            options={selectCustom3Ddl.filter(x => x.value >= (searchFormData.importannceLevelStart || 0))}
                            placeholder="end level"
                            isDisabled //lock this time
                          />
                        </div>}
                      </div>
                      
                    </div>
                    <div className="col-lg-6">
                      <label className="title control-label">
                        Event Notes
                      </label>
                      <div className="input-group">
                        <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                        <Select 
                          onChange={ e => onChangeSelectSearch(e, "eventNoteTS")}
                          value={selectDefaultDdl[searchFormData.eventNoteTS]}
                          options={selectDefaultDdl}
                          isDisabled //lock this time
                        />
                        </div>
                        <input
                          type="search"
                          className="form-control col-lg-8"
                          name="eventNoteText"
                          value={searchFormData.eventNoteText}
                          onChange={onChangeTextSearch}
                          //onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                          disabled //lock this time
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p>&nbsp;</p>
              <div className="card border-secondary"> {/* Status */}
                <h5 className="card-header text-white"
                  style={{backgroundColor:"#a58ede", cursor:"pointer"}}
                  onClick={ () => setIsHidden({ ...isHidden, status: !isHidden.status})}>
                  <i className={"fa fa-" + (isHidden.status ? "plus" : "minus") + "-square-o"} />  Status
                </h5>
                <div className="card-body" hidden={isHidden.status}>
                  <div className="row">
                    <div className="col-lg-6">
                      <label className="title control-label">
                        Case Status
                      </label>
                      <Select
                        onChange={ e => onChangeSelectSearch(e, "caseStatusId")}
                        value={caseStatusDdl.filter(x => x.value === searchFormData.caseStatusId)}
                        options={caseStatusDdl}
                      />
                    </div>
                  </div>
                </div>
              </div>
              { 
                // ----------------------------------button---------------------------------------
              }
              <div className="card-body text-right">
              <button
                type="button"
                className="btn btn-secondary mr-2"
                onClick={() => setSearchFormData(defaultSearchData)}
              >
                <i className="fa fa-refresh" /> Clear
              </button>
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={submitsearch}
                  >
                  <i className="fa fa-search" /> Search
                </button>
              </div>
              
              <hr style={{borderTop:"1px solid rgb(173, 173, 173)"}}/>
              {
                // ----------------------------------Result---------------------------------------
              }
              <div className="card border-secondary">
                <h5 className="card-header text-white bg-primary">  Result</h5>
                <div className="card-body">
                  <div className="row">
                    <div className="table-responsive">
                        <button type="button" className="btn btn-primary ml-2" onClick={() => {setShowManageColumns(true)}}>
                          <i className="fa fa-cog"></i> Manage Columns
                        </button>
                        <button type="button" className="btn btn-primary mr-2" 
                          style={{position:"absolute", right:0}} 
                          onClick={() => exportExcel()} >
                          <i className="fa fa-external-link"></i> Export file
                        </button>
                      <a href="#down" id="top" style={{position:"absolute", right:"0px", padding:"63px 17px 0 0", zIndex:"1"}}>
                        <i className="fa fa-arrow-down" style={{color:"#c8c8c8"}}/>
                      </a>
                      <DataTable
                        noHeader={true}
                        pagination={true}
                        onSort={handleSort}
                        sortFunction={customSort} 
                        paginationPerPage={50}
                        paginationRowsPerPageOptions={[10, 20, 50, 100]}
                        columns={resultColumns.filter(columns => listColumnsShow.includes(columns.selector)||columns.show === 1 )}
                        data={dataResult.filter(dataResult => dataResult.Matter != null)}
                        
                      />
                      <a href="#top" id="down" style={{position:"absolute", right:"0px", padding:"0 17px"}}>
                        <i className="fa fa-arrow-up" style={{color:"#c8c8c8"}}/>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> 

          {/* Modal Manage Columns*/}
          <Modal
            //size="lg"
            dialogClassName="modal-w2 columnsManageCustom"
            show={showManageColumns}
            onHide={() => {
              setShowManageColumns(false);
            }}
            centered
          >
            <Modal.Header closeButton className="replaceCloseBtn">
              <Modal.Title>
                <i className="fa fa-columns" /> Manage Columns
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="container">
                <div className="row">
                  {Object.keys(columnsCheckDefault).map( (e) => checkInputManageColumn(e))}
                </div>
              </div>
            </Modal.Body>
          </Modal>
          {/* Modal Manage columns*/}

          {/* Modal Loading */}

      
          <Modal
              size="sm"
              dialogClassName="main-modal"
              show={loading}

              onHide={() => {
                setLoading(false);
              }}
              centered
            >
              
              <Modal.Body>
                <div className="text-center mt-2">
                  <h1>
              <i className="fa fa-hourglass" /> </h1> <br/> Now processing a report, please wait a minute.
              
              </div>
              </Modal.Body>
            </Modal>
      
          {/* Modal Loading */}               
        </Layout>
      );
};

export default Search;